import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import manageFAQStore from '../../store/editFAQStore';
import { LOCALES } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import MultiLanguageInput from '~/view/components/Controls/MultiLanguageInput/MultiLanguageInput';
import Text from '~/view/components/Text/Text';
import './style.scss';

const EditFAQQuestion: FC = observer((): ReactElement => {
  const { FAQ, validation } = manageFAQStore;

  const onChangeQuestion = useCallback(
    (value: string, locale: LOCALES) => {
      const isEnLocale: boolean = locale === LOCALES.EN;

      manageFAQStore.changeFAQHandler({ question: { ...FAQ.question, [locale]: value } });

      manageFAQStore.updateValidation({
        question: {
          enValid: isEnLocale ? true : validation.question.enValid,
          enErrorText: isEnLocale ? undefined : validation.question.enErrorText,
          arValid: !isEnLocale ? true : validation.question.arValid,
          arErrorText: !isEnLocale ? undefined : validation.question.arErrorText,
        },
      });
    },
    [FAQ.question, validation]
  );

  return (
    <div className="d-flex flex-column gap-10">
      <Text type="block-header" text="question" required />

      <MultiLanguageInput
        enText={FAQ.question.en}
        arText={FAQ.question.ar}
        onChangeValue={onChangeQuestion}
        placeholder={localeStore.t('question')}
        validation={validation.question}
        maxLength={250}
        className="edit-faq-question__input"
      />
    </div>
  );
});

export default EditFAQQuestion;
